import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  ToolbarModule,
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  TableModule,
} from 'beyond-util';
import { NacinPlacanjaComponent } from './nacin-placanja.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    NgxSpinnerModule,
  ],
  declarations: [NacinPlacanjaComponent],
  entryComponents: [NacinPlacanjaComponent],
  exports: [NacinPlacanjaComponent],
  providers: [],
})
export class NacinPlacanjaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/nacin-placanja/nacin-placanja.module.ts